import {useLocation, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import MenuItem from "./Variables/MenuItem";

export default function Menu({menuHidden, className, setMenuHidden, ...props}) {
    const location = useLocation();
    const navigate = useNavigate();
    const {state} = location;

    useEffect(() => {
        if (location?.pathname === "/" && state?.element === "home") {
            window.scrollTo(0, 0);
        } else if (state && state.element) {
            let element = document.getElementById(state.element);
            if (!element) return;
            element.scrollIntoView({behavior: "smooth"});
        }

    }, [state])


    function handleClick(item) {
        // return;
        if (item?.unaunthenticated) {
            window.open(item.link, "_blank")
            return;
        }
        if (item?.link === "/" && location?.pathname === "/") {
            if (item.id === "home") {
                // smooth scroll to top
                window.scrollTo({

                    top: 0,
                    behavior: "smooth"
                });

                return;
            }
            let element = document.getElementById(item.id);
            if (!element) return;
            element.scrollIntoView({behavior: "smooth"});
        } else {
            navigate(item.link, {
                state: {element: item.id}
            });

        }
        if (item.link) {
            if (item.link.startsWith("#")) {
                let element = document.getElementById(item.link.substring(1));
                if (!element) return;
                element.scrollIntoView({behavior: "smooth"});
                return;

            }
        }

        setMenuHidden(true)

    }


    return (<div
        className={` ${menuHidden ? "hidden lg:flex" : "flex"} ${className} gap-3 top-to-bottom lg:gap-12  justify-center items-start lg:items-center  flex-1  flex-col lg:flex-row `}>

        {MenuItem.map((item, index) => {
            return (<a onClick={() => handleClick(item)} key={index} className={"cursor-pointer w-full md:w-auto  "}>
                    {item.title}
                </a>

            )


        })}


    </div>)
}